import React, { useState, useEffect, useRef } from "react";
import { Checkbox , Radio, Space, Button  } from 'antd';
import ImageDisplay from "../../components/ImageDisplay/ImageDisplay";


function isSameArray (arr1, arr2){
    if(arr1.length != arr2.length){
        return false;
    }
    for (let i = 0; i < arr1.length; i++) {
        if(arr2.indexOf(arr1[i]) === -1){
            return false;
        }
    }
    return true;
}

function ansStrToArray (ansStr){
    const l = ansStr.split(',');
    const result = [];
    l.forEach(ele => {
        result.push(ele.charCodeAt(0) - 'A'.charCodeAt(0));
    });
    return result;
}

function MultipleChoice (props){
    const {question, options, correctAnswer, reason, selectOption = [], url} = props;
    const [selOpt, setSelOpt] = useState(selectOption);
    const isCorrect = isSameArray(selectOption, correctAnswer);
    const startTime = useRef(null);
    const submitted = selectOption.length !== 0;
    useEffect(()=>{
        startTime.current = Date.now();
    }, [])
    
    const handleValueChange = (v, key)=>{
        const newSO = selOpt.slice();
        if(newSO.indexOf(key) === -1){
            newSO.push(key);
        }else{
            newSO.splice(newSO.indexOf(key), 1);
        }
        console.log('newSO', newSO)
        setSelOpt(newSO);
        // selOptionRef.current = newSO;
        // const index = array.indexOf(5);

        // if(!v){
        //     selectOption.splice(selectOption.indexOf(v), 1);
        // }else{
        //     selectOption.push(v);
        // }

        // setSelectedOption(newSO);
        // props.valueChange({...props, selectOption: newSO, isCorrect: isSameArray(newSO, (correctAnswer))});
    }

    const getAnswerOptionBorderStyle = (item, index)=>{
        let result = '0.5px lightblue solid';
        if(submitted){
            if((correctAnswer).indexOf(index) > -1){
                if(selectOption.indexOf(index) > -1){
                    result = '2px lightgreen solid';
                }else{
                    result = '2px red solid';
                }
            }
        }
        return result;
    }

    const handleSubmit = ()=>{
        const timeSpend = Date.now() - startTime.current;
        props.valueChange({...props, selectOption: selOpt, time_spend: timeSpend});
        props.onSubmit({...props, selectOption: selOpt, time_spend: timeSpend})
    }

    return (
        <Space direction="vertical" className= 'h-100 mt-2 w-100'>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {props.index + 1} : {question}
            </p>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <ImageDisplay imgList={url}/>
            </div>
            {/* <Checkbox.Group onChange={handleValueChange} value={selectOption} style={{width: '100%', }}> */}
                {/* <Space direction="vertical" style={{width: '100%', }}> */}
                    {/* {options.map((ele, key)=>
                        <Radio key={key} value={key} style={{width: '100%', border: getAnswerOptionBorderStyle(ele, key), borderRadius: '5px', padding: '10px'}}>
                            {ele}
                        </Radio>)} */}
                {/* </Space> */}
            {/* </Checkbox.Group> */}
            
            {/* <Checkbox.Group className="checkbox-group" options={options.map((ele,key)=>{return {label: ele, value: key}})} value={selectOption} onChange={handleValueChange}/> */}


            {/* <Checkbox.CheckboxGroup options={options.map((ele, key)=>{
                return {label: ele, value: key}
            })} value={Array.from(selectOption)} onChange={handleValueChange} /> */}

            {options.map((ele, key)=>
                // <Radio
                //     key={key} 
                //     value={key}
                //     checked={selectOption.has(key)}
                //     style={{width: '100%', border: getAnswerOptionBorderStyle(ele, key), borderRadius: '5px', padding: '10px'}}
                //     onChange={handleValueChange}
                // >
                //     {ele}
                // </Radio>)
                <div key={key} className="form-check checkbox-container" style={{border: getAnswerOptionBorderStyle(ele, key)}}>
                    <input className="form-check-input" type="checkbox" onChange={(ele)=>handleValueChange(ele, key)} id={question + key} checked={selOpt.indexOf(key) !== -1}/>
                    <label className="form-check-label" htmlFor={question + key}>
                        {ele}
                    </label>
                </div>
            )}
            <Button onClick={handleSubmit} style={{width: '100%'}} type={'primary'}>Submit</Button>
            {submitted && !isCorrect && reason ?
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
                :
                null
            }
        </Space>
    );
}

export default MultipleChoice;